<template>
  <div id="paymentMethod" class="m-auto max-w-[327px] md:max-w-[370px]">
    <img alt="" class="mx-auto mb-4 mt-auto" :src="cardIconUrl" />
    <div v-if="paymentMethod === 'fincode'" data-testid="fincode-form">
      <div class="flex justify-center">
        <form id="fincode-form" class="flex justify-center">
          <div id="fincode" data-testid="fincode"></div>
        </form>
      </div>
      <div class="my-3 px-2 text-center">
        <br />
        <div v-for="message in paymentErrorMessages" :key="message">
          <AtomsErrorText class="tracking-tight md:text-base" lang="en">{{ message }}</AtomsErrorText>
        </div>
      </div>
    </div>
    <div v-else data-testid="payjp-form">
      <div class="flex flex-col px-0 pb-4">
        <div class="flex h-16 items-center justify-between border-t border-light-bd-muted px-0">
          <div class="flex w-full items-center justify-between px-2">
            <p class="mr-4 block">Card number</p>
            <div class="w-[53%] pt-1 md:w-[63%]">
              <div id="number-form" class="payjs-outer" data-testid="credit-card-number-form">
                <!-- ここにカード番号入力フォームが生成されます -->
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col border-t border-light-bd-muted px-0 md:flex-row md:items-center">
          <div class="flex h-16 w-full items-center justify-between border-light-bd-muted md:w-1/2 md:border-b-0">
            <div class="flex w-full items-center justify-between px-2">
              <p class="mr-2 block whitespace-nowrap">Expiry date</p>
              <div class="w-[53%] pt-1">
                <div id="expiry-form" class="payjs-outer" data-testid="credit-card-expiry-form">
                  <!-- ここに有効期限入力フォームが生成されます -->
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 flex w-full items-center justify-between border-light-bd-muted md:mt-0 md:w-1/2 md:border-l md:pl-3">
            <div class="flex w-full items-center justify-between px-2 md:px-0">
              <div class="flex">
                <p class="mr-1 block whitespace-nowrap">CVC number</p>
                <AtomsPrimaryTextButton :on-click="onClickCVC">
                  <img alt="" src="@/assets/icon/question.svg" />
                </AtomsPrimaryTextButton>
              </div>
              <div class="w-[53%] pt-1 md:w-[20%]">
                <div id="cvc-form" class="payjs-outer" data-testid="credit-card-cvc-form"><!-- ここにCVC入力フォームが生成されます --></div>
              </div>
            </div>
          </div>
        </div>
        <div class="items-left my-3 px-2">
          <br />
          <div v-for="message in paymentErrorMessages" :key="message">
            <AtomsErrorText class="tracking-tight md:text-base" lang="en">{{ message }}</AtomsErrorText>
          </div>
        </div>
      </div>
      <div class="relative bg-beige1 p-4">
        <img alt="" class="absolute right-4 top-4" src="@/assets/img/parts/feel-safe.svg" />
        <p class="mb-3 text-gold1">Reliable, Secure, and Private.</p>
        <div class="mb-3 flex">
          <img alt="" class="mr-3" src="@/assets/icon/check/simple.svg" />
          <p class="text-sm tracking-normal">Meets PCI DSS security standards.</p>
        </div>
        <div class="mb-3 flex">
          <img alt="" class="mr-3" src="@/assets/icon/check/simple.svg" />
          <p class="text-sm tracking-normal">Protected by industry-standard encryption.</p>
        </div>
        <div class="flex">
          <img alt="" class="mr-3" src="@/assets/icon/check/simple.svg" />
          <p class="text-sm tracking-normal">Adherence to strict data privacy regulations.</p>
        </div>
      </div>
      <img alt="" class="mx-auto my-8" src="@/assets/img/parts/payjp.svg" />
    </div>
    <p class="mb-6 text-center text-sm tracking-normal md:text-base">
      While your booking is being processed, a temporary authorization hold will be placed on your credit card. Charges occur upon confirmed reservation.
    </p>
    <div class="items-left my-5 px-2">
      <AtomsErrorText v-show="paymentErrorMessages.length > 0" class="tracking-tight md:text-base" lang="en">There are some parts that are not entered correctly.</AtomsErrorText>
    </div>
    <CVCModal :close="close" :is-open="isOpen" />
  </div>
</template>

<script lang="ts" setup>
import { useModal } from '@/composables/ui/useModal';
// public/ 配下の画像参照は :src バインディング経由で行う（コンパイル時 import 化を回避、JCAT-4981）
const cardIconUrl = '/img/parts/card.svg';
import type { PaymentMethod } from '@/wabunka-src/constants/paymentMethod';
import { CVCModal } from '@/wabunka-src/features/Experience';
interface Props {
  paymentErrorMessages: string[];
  paymentMethod: PaymentMethod;
}

defineProps<Props>();

const { isOpen, close, open } = useModal();

const onClickCVC = () => {
  open();
};
</script>
